<template>
  <div id="header_menu">
    <ul>
      <li><a><v-icon large style="margin: 0 5px 5px 0;" >{{ IconMenu }}</v-icon>Меню</a>
        <ul itemscope="itemscope" itemtype="http://schema.org/SiteNavigationElement">
          <li v-for="group in header_menu" ><a>{{ group.title }}</a> <v-icon> {{ IconMenuRight }} </v-icon>
            <ul>
              <li itemprop="name" v-for="item in group.items" >
                <router-link itemprop="url" :to="{ name: 'WithStatic', params: { sp_slug: item.slug }}" >
                  {{ item.name }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>

import {mdiMenuRight, mdiMenu} from '@mdi/js';
import { mapState } from "vuex";

export default {
  name: "HeaderMenu",
  data() {
    return {
      IconMenuRight: mdiMenuRight,
      IconMenu: mdiMenu,
    }
  },
  computed: mapState({
    header_menu: (state) => state.LandingM.common_params.header_menu,
  }),
}

</script>

<style scoped type="text/css">

#header_menu {
  clear: both;
  width: 100%;
}
#header_menu ul {
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: #2196f3;
}
#header_menu ul li {
  list-style: none;
  float: left;
  width: max-content;
}
#header_menu ul li a {
  display: block;
  padding: 5px 5px;
  text-decoration: none;
  text-align: center;
  color: white;
  font-size: 1.1rem;
}
/* Drop-down menu styles */

#header_menu ul li ul {
  position: absolute;
  visibility: hidden;
  margin: 0;
  padding: 0;
  z-index: 1000;
  background-color: #47a9f7;
  width: min-content;
}
#header_menu ul li ul li {
  display: flex;
  position: relative;
  padding: 5px;
  width: 100%;
}
#header_menu ul li ul li:hover {
  background-color: #5c5cb9;
}
#header_menu ul li ul li a {
  text-align: left;
  margin-right: auto;
  width: max-content;
}
#header_menu ul li:hover > ul {
  display: block;
  visibility: visible;
}

/* Submenu styles */

#header_menu ul ul li ul {
  position: absolute;
  display: block;
  visibility: hidden;
  vertical-align: top;
  left: 100%;
  top:0;
  /*  margin-top: -32px;*/
}
#header_menu ul ul li i {
  position: relative;
  float: right;
}
</style>